import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { moduloRPlus } from '../../diccionarios/RPlusModulo.js';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { Subscription } from "rxjs";
import { LfsaBotonEditarGridComponent } from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import { IGaritaResponse } from '../../modelos/IMantGarita';
import { IMantBascula } from '../../modelos/IMantBascula';
import { IUsuarioAll } from '../../modelos/IUsuario.js';
import { RPlusService } from '../../services/rplus.service';

@Component({
  selector: 'app-consultar-procesos',
  templateUrl: './consultar-procesos.component.html',
  styleUrls: ['./consultar-procesos.component.css']
})
export class ConsultarProcesosComponent implements OnInit {

  public DAT_TITULOS: any = moduloRPlus.titulos.consultaDeProcesos;
  public DAT_BTNS: any = moduloRPlus.button.buttonsNombre;
  public DAT_BTNCSS: any = moduloRPlus.button.buttonsCss;
  public DAT_AG_GRID: any = moduloRPlus.agGrid;
  public DAT_MSG: any = moduloRPlus.mensajes;

  public gridApi: any;
  public gridColumnApi: any;
  public frameworkComponents: any;
  public columnDefs: any[] = [];
  public rowData: any[] = [];
  public garitaSelect: IGaritaResponse[] = [];
  public basculaSelect: IMantBascula[] = [];

  public isCreate: boolean = false;
  public tituloModal: string = '';
  public loading: boolean = false;
  public showUsers: boolean = false;
  public queryDate;

  public agregarForm = new FormGroup({
    date: new FormControl(null, []),
  });

  public cmbUsuarios: IUsuarioAll[] = [];
  private subscription = new Subscription();

  constructor(
    private _util: UtilsService,
    private rplusService: RPlusService
  ) {
  }

  ngOnInit() {
    this.queryDate = new Date().toISOString().split('T')[0];
    this.girdComponent();
    this.obtenerTodo(this.queryDate);
  }

  girdComponent() {
    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };

    this.columnDefs = [
      {
        headerName: 'Fecha',
        field: 'dateInit',
        sortable: true,
        filter: true
      },
      {
        headerName: 'Hora',
        field: 'hourInit',
        sortable: true,
        filter: true,
      },
      {
        headerName: 'Acción',
        field: 'event',
        sortable: true,
        filter: true,
      },
      {
        headerName: 'Tipo',
        field: 'type',
        sortable: true,
        filter: true,
      },
      {
        headerName: 'Usuario',
        field: 'user',
        sortable: true,
        filter: true,
      },
      {
        headerName: 'Status',
        field: 'status',
        sortable: true,
        filter: true,
      },
      {
        headerName: 'Fecha Fin',
        field: 'dateEnd',
        sortable: true,
        filter: true,
      },
      {
        headerName: 'Hora Fin',
        field: 'hourEnd',
        sortable: true,
        filter: true,
      },
    ];
  }

  obtenerTodo(date) {
    this.loading = true;
    console.log("FECHA A CONSULTAR", date)
    this.rplusService.getAll(date).subscribe(
      (resp) => {
        console.log("resp", resp)
        this.rowData = resp;
        this.loading = false;
      },
      (error) => {
        console.log("error", error)
        this.rowData = [];
        this.loading = false;
      }
    )
  }

  getPreviousDay(date = new Date()) {
    let previous = new Date(date.getTime());
    previous.setDate(date.getDate() - 1);

    return previous.toISOString().split('T')[0];
  }

  getNextDay(date = new Date()) {
    let next = new Date(date.getTime());
    next.setDate(date.getDate() + 1);

    return next.toISOString().split('T')[0];
  }

  previousDate() {
    this.queryDate = this.getPreviousDay(new Date(this.queryDate));
    this.obtenerTodo(this.queryDate);
  }

  nextDate() {
    this.queryDate = this.getNextDay(new Date(this.queryDate));
    this.obtenerTodo(this.queryDate);
  }

  currentDate() {
    this.queryDate = new Date().toISOString().split('T')[0];
    this.obtenerTodo(this.queryDate);
  }

  dateSelected() {
    this.queryDate = this.agregarForm.get('date').value;
    this.obtenerTodo(this.queryDate);
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    params.api.sizeColumnsToFit();
  }

}
